import { render, staticRenderFns } from "./getting-discount.vue?vue&type=template&id=bd0c27e2&"
import script from "./getting-discount.vue?vue&type=script&lang=ts&"
export * from "./getting-discount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd0c27e2')) {
      api.createRecord('bd0c27e2', component.options)
    } else {
      api.reload('bd0c27e2', component.options)
    }
    module.hot.accept("./getting-discount.vue?vue&type=template&id=bd0c27e2&", function () {
      api.rerender('bd0c27e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/getting-discount/getting-discount.vue"
export default component.exports